import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PageContainer from '../../../components/PageContainer';
import { getRafagaConfig, guardarNegocio, guardarAccesos } from '../../../services/modules/Rafaga';
import { getServicios } from '../../../services/modules/ServiciosCatalogo';
import ConfiguradorGrupos from './ConfiguradorGrupos';
import AsignadorRafaga from './AsignadorRafaga';
import { gruposIniciales,claveGrupo } from '../../dashboard/GruposRafaga';

const initial = { nombre: '', direccion: '', telefono: '', nit: '', razon_social: '', correo: '', codigo_establecimiento: '',
  codigo_postal: '', municipio: '', departamento: '', pais: 'GT', afiliacion_iva: '' };
const labels = { nombre: 'Nombre del negocio', direccion: 'Dirección', telefono: 'Teléfono', nit: 'NIT del emisor',
  razon_social: 'Razón social', correo: 'Correo', codigo_establecimiento: 'Código de establecimiento FEL', codigo_postal: 'Código postal',
  municipio: 'Municipio', departamento: 'Departamento', pais: 'País', afiliacion_iva: 'Afiliación IVA' };

export default function ConfiguracionNegocio() {
  const [negocio,setNegocio] = useState(initial);
  const [accesos,setAccesos] = useState([]);
  const [grupos,setGrupos] = useState(gruposIniciales);
  const [servicios,setServicios] = useState([]);
  const [errorServicios,setErrorServicios] = useState(false);
  const [cargandoServicios,setCargandoServicios] = useState(true);
  const [loading,setLoading] = useState(true);
  const [saving,setSaving] = useState(false);
  const [procesandoLogos,setProcesandoLogos] = useState(false);
  const [notice,setNotice] = useState(null);
  useEffect(() => {
    getRafagaConfig().then((data) => { setNegocio({ ...initial, ...data.negocio }); setAccesos(data.accesos.map((a) => ({...a,grupo_clave:claveGrupo(a)}))); setGrupos(data.grupos ?? gruposIniciales); })
      .catch(() => setNotice({ severity:'error', text:'No se pudo cargar la configuración. Verifica que la migración de Ráfaga esté aplicada.' }))
      .finally(() => setLoading(false));
  },[]);
  useEffect(() => {
    let active = true;
    getServicios({ activos:'1', completo:'1' }).then((data) => { if(active) {setServicios(data);setErrorServicios(false);} })
      .catch(() => { if(active) setErrorServicios(true); })
      .finally(() => { if(active) setCargandoServicios(false); });
    return () => { active=false; };
  },[]);
  const save = async (action) => {
    setSaving(true); setNotice(null);
    try { await action(); setNotice({ severity:'success', text:'Configuración guardada.' }); }
    catch(e) { setNotice({ severity:'error', text:e.response?.data?.message || 'No se pudo guardar.' }); }
    finally { setSaving(false); }
  };
  return <PageContainer>
    <Stack direction="row" justifyContent="space-between" alignItems="center"><Typography variant="h4" fontWeight={800}>Negocio y Zona de Ráfaga</Typography>
      <Button component={Link} to="/dashboard">Ir al dashboard</Button></Stack>
    {notice && <Alert severity={notice.severity}>{notice.text}</Alert>}
    <Card><CardContent><Stack spacing={2}>
      <Typography variant="h6">Datos del negocio</Typography>
      <Typography color="text.secondary">Se usan en los comprobantes y como datos del emisor FEL. Las credenciales del certificador se conservan en el servidor.</Typography>
      <Box sx={{ display:'grid', gridTemplateColumns:{xs:'1fr',md:'repeat(3,1fr)'}, gap:2 }}>
        {Object.keys(initial).map((key) => <TextField key={key} label={labels[key]} value={negocio[key] || ''}
          required={key === 'nombre'} disabled={loading || saving} onChange={(e) => setNegocio((n) => ({ ...n, [key]:e.target.value }))} />)}
      </Box>
      <Button variant="contained" disabled={loading || saving || !negocio.nombre.trim()} onClick={() => save(() => guardarNegocio(negocio))}>Guardar datos del negocio</Button>
    </Stack></CardContent></Card>
    <Card><CardContent><Stack spacing={2}><ConfiguradorGrupos grupos={grupos} setGrupos={setGrupos} accesos={accesos} disabled={loading || saving}
      onProcessing={(value) => {setProcesandoLogos(value);if(value) setNotice(null);}} onError={(text) => setNotice({severity:'error',text})} />
      <Button variant="contained" disabled={loading || saving || procesandoLogos} onClick={() => save(() => guardarAccesos(accesos,grupos))}>Guardar grupos y botones</Button>
    </Stack></CardContent></Card>
    <Card><CardContent><Stack spacing={2}>
      <Typography variant="h6">Botones de la Zona de Ráfaga</Typography>
      <Button component={Link} to="/servicios-catalogo">Crear o modificar servicios y precios</Button>
      {errorServicios && <Alert severity="error">No se pudo cargar el catálogo de servicios. Recarga la página para volver a intentarlo.</Alert>}
      {cargandoServicios && <Typography>Cargando servicios…</Typography>}
      <AsignadorRafaga servicios={servicios} accesos={accesos} setAccesos={setAccesos} grupos={grupos}
        disabled={loading || saving || cargandoServicios || errorServicios} />
      <Button variant="contained" disabled={loading || saving || procesandoLogos} onClick={() => save(() => guardarAccesos(accesos,grupos))}>Guardar Zona de Ráfaga</Button>
    </Stack></CardContent></Card>
  </PageContainer>;
}
